import { render } from "./Peyment.vue?vue&type=template&id=4c8dbb86&scoped=true"
import script from "./Peyment.vue?vue&type=script&lang=js"
export * from "./Peyment.vue?vue&type=script&lang=js"

import "./Peyment.vue?vue&type=style&index=0&id=4c8dbb86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8dbb86"]])

export default __exports__